import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  G2_P4_Tab1_Title: {
    id: `guide02.page04.tab01.title`,
  },
  G2_P4_Tab2_Title: {
    id: `guide02.page04.tab02.title`,
  },
  G2_P4_Tab3_Title: {
    id: `guide02.page04.tab03.title`,
  },
  G2_P4_Tab4_Title: {
    id: `guide02.page04.tab04.title`,
  },
  G2_P4_Tab5_Title: {
    id: `guide02.page04.tab05.title`,
  },
  G2_P4_Tab6_Title: {
    id: `guide02.page04.tab06.title`,
  },

  //Slide1
  G2_P4_S1_Title: {
    id: `guide02.page04.slide01.title`,
  },
  G2_P4_S1_Description: {
    id: `guide02.page04.slide01.description`,
  },
  G2_P4_S1_P1_Title: {
    id: `guide02.page04.slide01.p1.title`,
  },
  G2_P4_S1_P1_Description: {
    id: `guide02.page04.slide01.p1.description`,
  },
  G2_P4_S1_P1_ButtonLabel1: {
    id: `guide02.page04.slide01.p1.buttonLabel1`,
  },
  G2_P4_S1_P1_ButtonLabel2: {
    id: `guide02.page04.slide01.p1.buttonLabel2`,
  },
  G2_P4_S1_P2_Title: {
    id: `guide02.page04.slide01.p2.title`,
  },
  G2_P4_S1_P2_Description: {
    id: `guide02.page04.slide01.p2.description`,
  },

  //Slide2
  G2_P4_S2_Title: {
    id: `guide02.page04.slide02.title`,
  },
  G2_P4_S2_Description: {
    id: `guide02.page04.slide02.description`,
  },
  G2_P4_S2_P1_Title: {
    id: `guide02.page04.slide02.p1.title`,
  },
  G2_P4_S2_P1_ButtonLabel: {
    id: `guide02.page04.slide02.p1.buttonLabel`,
  },
  G2_P4_S2_P1_Description: {
    id: `guide02.page04.slide02.p1.description`,
  },

  //Slide3
  G2_P4_S3_Title: {
    id: `guide02.page04.slide03.title`,
  },
  G2_P4_S3_Description: {
    id: `guide02.page04.slide03.description`,
  },
  G2_P4_S3_ButtonLabel: {
    id: `guide02.page04.slide03.buttonLabel`,
  },

  //Slide 4
  G2_P4_S4_Title: {
    id: `guide02.page04.slide04.title`,
  },
  G2_P4_S4_Description: {
    id: `guide02.page04.slide04.description`,
  },
  G2_P4_S4_ButtonLabel: {
    id: `guide02.page04.slide04.buttonLabel`,
  },

  //Slide5
  G2_P4_S5_Title: {
    id: `guide02.page04.slide05.title`,
  },
  G2_P4_S5_Description: {
    id: `guide02.page04.slide05.description`,
  },
  G2_P4_S5_ButtonLabel: {
    id: `guide02.page04.slide05.buttonLabel`,
  },

  //Slide6
  G2_P4_S6_Title: {
    id: `guide02.page04.slide06.title`,
  },
  G2_P4_S6_Description: {
    id: `guide02.page04.slide06.description`,
  },
  G2_P4_S6_ButtonLabel: {
    id: `guide02.page04.slide06.buttonLabel`,
  },

  //Modals
  G2_P4_M_PanningSingle_Title: {
    id: `guide02.page04.modal.panningSingle.title`,
  },
  G2_P4_M_PanningSingle_Description: {
    id: `guide02.page04.modal.panning.description`,
  },

  G2_P4_M_PanningStereo_Title: {
    id: `guide02.page04.modal.panningStereo.title`,
  },
  G2_P4_M_PanningStereo_Description: {
    id: `guide02.page04.modal.panningStereo.description`,
  },

  G2_P4_M_Upmixing_Title: {
    id: `guide02.page04.modal.upmixing.title`,
  },
  G2_P4_M_Upmixing_Description: {
    id: `guide02.page04.modal.upmixing.description`,
  },

  G2_P4_M_MultiInstances_Title: {
    id: `guide02.page04.modal.multiInstances.title`,
  },
  G2_P4_M_MultiInstances_Description: {
    id: `guide02.page04.modal.multiInstances.description`,
  },

  G2_P4_M_QuadBus_Title: {
    id: `guide02.page04.modal.quadBus.title`,
  },
  G2_P4_M_QuadBus_Description: {
    id: `guide02.page04.modal.quadBus.description`,
  },

  G2_P4_M_3dReverb_Title: {
    id: `guide02.page04.modal.3dReverd.title`,
  },
  G2_P4_M_3dReverb_Description: {
    id: `guide02.page04.modal.3dReverb.description`,
  },

  G2_P4_M_Lfe_Title: {
    id: `guide02.page04.modal.lfe.title`,
  },
  G2_P4_M_Lfe_Description: {
    id: `guide02.page04.modal.lfe.description`,
  },
});
